/* eslint-disable react-hooks/exhaustive-deps */
import { cloneDeep, isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react'
import { getClientsList } from '../../../../apis/finances/bank';
import useForm from '../../../../hooks/useForm';
import { getParams } from '../../../../utils/params';
import Button from '../../../../components/Button';
import Filters from '../../../../components/Filters';
import Modal, { ModalHeader, ModalTab } from '../../../../components/Modal'
import { ControlTable } from '../../../../components/Table';

const ClientMappingModal = ({ open, setOpen, tagForm, setTagForm }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [tabList, setTabList] = useState([]);
  const [filters] = useState([
    {
      title: "거래처명",
      type: "input",
      key: "search.name",
    },
  ]);
  const [fields] = useState([
    {
      title: "거래처명",
      key: "name",
    },
  ])

  useEffect(() => {
    setTabList([
      { label: '거래처', action: setActiveTab },
      { label: '카드사', action: setActiveTab },
      { label: '카드사용처', action: setActiveTab },
      { label: '직원', action: setActiveTab },
    ])
  }, [])

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedData, setSelectedData,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reset
  } = useForm(
    {
      search: {
        name: ''
      },
      page: 0,
      limit: 10,
    },
  )

  useEffect(() => {
    if (open)
    {
      submit(form);
      setSubmit(submit)
    }
  }, [open, activeTab]);

  const submit = (params) => {
    let _params = cloneDeep(params)
    switch (activeTab)
    {
      case 0:
        _params = {
          ..._params,
          type: ['company']
        }
        break;
      case 1:
        _params = {
          ..._params,
          type: ['cardCompany']
        }
        break;
      case 2:
        _params = {
          ..._params,
          type: ['cardUseStore']
        }
        break;
      case 3:
        _params = {
          ..._params,
          type: ['employee']
        }
        break;
      default:
        break;
    }

    getClientsList(getParams(_params))
      .then((res) => {
        setList(res.data.clientList)
        setTotal(res.data.totalCount)
      })
      .catch(() => { })
      .finally(() => setIsLoading(false))
  };

  const cancel = () => {
    setOpen(false)
    setSelectedData({})
    setActiveTab(0)
    reset()
  }

  const handleApply = () => {
    setTagForm({
      ...tagForm,
      clientIdx: selectedData.idx,
      clientName: selectedData.name
    })
    cancel()
  }

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="client-mapping-modal">
        <ModalHeader>거래처 불러오기</ModalHeader>
        <ModalTab tabList={tabList} active={activeTab} />
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          isSelect
          fields={fields}
          list={list}
          isLoading={isLoading}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          submit={handleSubmit}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
        />
        <div className="submit-button-wrap float-right margin-top-32">
          <Button
            className="button"
            size="lg"
            label="취소"
            color="text"
            action={cancel}
          />
          <Button
            className="button"
            size="lg"
            label="적용하기"
            disabled={isEmpty(selectedData)}
            action={handleApply}
          />
        </div>
      </div>
    </Modal>
  )
}

export default ClientMappingModal;